import { Construction } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { EmptyState } from '@vnetwork/ui/data';
import { AccountBreadcrumbs } from './components/account-breadcrumbs';

/**
 * Customer Events — upcoming customer birthday / founding-day calendar.
 *
 * The legacy `datacentral-client-v4` has this page (`/account/customer-events`,
 * gated behind the `Customers:create` scope), but its endpoint
 * `GET /customers/calendar-events` is NOT implemented in the current
 * `datacentral-api-v4` backend (no such route in `modules/customer/customer.routes.go`;
 * the only calendar route is the unrelated employee `/events/month/:year/:month`).
 * Until the backend ports the endpoint, this stays a "coming soon" stub — we do
 * NOT call the missing endpoint or fake data.
 */
export default function CustomerEventsPage() {
  return (
    <Container size="full">
      <PageHeader
        breadcrumbs={<AccountBreadcrumbs current="Customer Events" />}
        title="Customer Events"
        description="Upcoming birthday and founding-day events for your customers"
      />
      <EmptyState
        icon={<Construction size={24} />}
        title="Coming soon"
        description="Customer events aren't available yet — the backend endpoint has not been implemented in this API."
      />
    </Container>
  );
}
